/* Native Shopify catalog facade for the approved picker. */
(()=>{'use strict';
const cfg=window.__STEADI_ENGRAVING_CONFIG;
if(!cfg)return;
const previous=window.SteadiPickerCTA||{};
const catalog=async()=>[2,4,6].map(pack=>{
 const v=cfg.catalog.find(v=>Number(v.pack)===pack&&Number(v.engravedCount)===0&&!v.color&&!v.legacy&&!v.retired);
 return {pack,price:v?.price,available:!!v?.available,variantId:String(v?.id||'')};
});
window.SteadiPickerCTA={...previous,commerce:{...previous.commerce,catalog},async addSelection(_engine,selection){
 if(!window.SteadiEngravingUI)throw Error('Your cart is still loading. Please try again.');
 return window.SteadiEngravingUI.addSelection(selection);
},setSelection({pack,colors}){
 const r=document.getElementById('steadi-live-picker')?.shadowRoot;if(!r)return false;
 const change=i=>{if(i){i.checked=true;i.dispatchEvent(new Event('change',{bubbles:true}));}};
 if(pack===1)r.querySelector('#single-pack')?.click();else change(r.querySelector(`[name=pack][value="${pack}"]`));
 const solid=new Set(colors).size===1;r.querySelector(`[data-mode=${solid?'solid':'mix'}]`)?.click();
 colors.forEach((color,i)=>{if(!solid)r.querySelector(`[data-slot="${i}"]`)?.click();change(r.querySelector(`[name=color][value="${color.toLowerCase()}"]`));});return true;
}};
window.SteadiPickerABC=window.SteadiPickerCTA;
})();


/* Match native variant links to the current pack before any customer interaction. */
(()=>{
 'use strict';
 const cfg=window.__STEADI_ENGRAVING_CONFIG;
 const id=new URLSearchParams(window.location.search).get('variant');
 const initial=cfg?.catalog?.find(v=>String(v.id)===id&&!v.retired&&cfg.activePacks.includes(Number(v.pack)));
 if(!initial)return;
 let observer;
 function applyInitialPack(){
  const host=document.getElementById('steadi-live-picker');
  if(host?.dataset.ready!=='true'||!host.shadowRoot)return false;
  const selected=window.SteadiPickerCTA?.setSelection({pack:Number(initial.pack),colors:Array(Number(initial.pack)).fill('charcoal')});
  if(selected)observer?.disconnect();
  return !!selected;
 }
 if(!applyInitialPack()){
  observer=new MutationObserver(applyInitialPack);
  observer.observe(document.documentElement,{childList:true,subtree:true,attributes:true,attributeFilter:['data-ready']});
 }
})();
